export const Logo  = require( './logo.png');
export const LogoEscudo  = require( './escudo-uach-horizontal.png');
export const LogoRenovacion  = require( './logo-uach-renovacion.png');
export const PrintLogo  = require( './print_logo.png');
export const PreviewLogo  = require( './preview_logo.png');
export const Inbox  = require( './empty_inbox.png');
export const Sent  = require( './empty_sent.png');
export const Drafts  = require( './empty_drafts.png');
export const Signed  = require( './empty_onreview.png');
export const Modificar = require( './modificar.svg' )
export const fwd = require ( './fwd.png' )
export const alert = require ( './alert.png' )

export { AddRow,AddTable,AddColumn,
  RemoveColumn,RemoveRow,RemoveTable,Permission, Success, Saved, Info, SwitchUser, PendingReview, PendingSign, SendSign, SendReview, DownloadReport } from './TableIcons';



// WEBPACK FOOTER //
// ./src/img/index.js